const ADMIN_DASHBOARD_PATH = '/admin';
const LAST_ADMIN_DASHBOARD_ROUTE_KEY = 'lastAdminDashboardRoute';

function normalizeAdminDashboardUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin !== window.location.origin || parsed.pathname !== ADMIN_DASHBOARD_PATH) {
      return null;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function rememberAdminDashboardRoute(url: string): void {
  const normalizedUrl = normalizeAdminDashboardUrl(url);
  if (!normalizedUrl) {
    return;
  }

  window.localStorage.setItem(LAST_ADMIN_DASHBOARD_ROUTE_KEY, normalizedUrl);
}

export function getLastAdminDashboardRoute(): string {
  return normalizeAdminDashboardUrl(window.localStorage.getItem(LAST_ADMIN_DASHBOARD_ROUTE_KEY))
    ?? ADMIN_DASHBOARD_PATH;
}
